<template >
  <div class="total-test">

    <Card class="p-m-3" :class="{'card-loading': isLoading}">

      <template #title>
<div style="height: .5em;     margin: -0.5em;">
	 	<ProgressBar
			class="p-m-0 p-p-0"
			v-if="isLoading"
			mode="indeterminate"
			style="height: .5em"
		/>
		</div>
          <h2 >ממוצע מבחנים</h2>
	 </template >
      <template #content>
          <h3 class="no-content" v-if="!isLoading && getSubjectLesson.length === 0">אין נתונים להצגה</h3>
          <div class="p-grid">
              <div
                      @click="moveToData(status)"
                      class="p-col-12 p-sm-12 p-md-6 p-lg-6"
                      v-for="status in getSubjectLesson"

                      :key="status.id">

                  <div
                          v-tooltip.top="'לחץ לצפיה במבחנים'"
                          class="p-p-3  p-card item subject-tracking"
                          :class="`${getColorScore(getTestAvg(status))} ${(status.type)}`">
                      <h1 style="text-align: center">
                          {{ getTestAvg(status) }}
                      </h1>
                      <h2 style="text-align: center">
                          {{ status.hebrewName }}
                      </h2>
                  </div>
              </div>
          </div>

<!--          <div-->
<!--		   v-for="status in getSubjectLesson"-->
<!--		   :key="status.id"-->
<!--	   >-->
<!--          <div-->
<!--                  v-tooltip.top="'לחץ לצפיה במבחנים'"-->

<!--                  @click="moveToData(status)"-->
<!--                               class="p-grid item">-->
<!--            <h3 class="p-pr-3 p-col">-->
<!--              {{ status.hebrewName }}-->
<!--            </h3>-->
<!--		    <h3-->
<!--			    class=" p-pl-5 p-col"-->
<!--			    style="text-align: left"-->
<!--		    >-->
<!--              {{ getTestAvg(status) }}-->
<!--            </h3 >-->
<!--            <Divider-->
<!--			  type="dashed"-->
<!--			  class="divider-short-dialog"-->
<!--		  />-->
<!--          </div >-->
<!--        </div >-->
      </template >
    </Card >
  </div >
</template >

<script >
import {mapActions, mapState} from "vuex";
import Service from "@/service/Service";

export default {
  service: null,

  name: "total-test-card",
  props: {pupil: Object, startDate: Number, endDate: Number},
  components: {},
  data() {
    return {
      isLoading: true,
      totalTest: null
    };
  },

  mounted() {
    this.service = new Service();
    if (this.pupil) {
      this.getTotalTest();
    }
  },
  methods: {
      moveToData(status) {
          const routeData = this.$router.resolve({
              name: 'testTable',
              query: {
                  pupil: this.pupil.id,
                  subject: status.id,
                  start: this.startDate,
                  end: this.endDate,
              }
          })
          window.open(routeData.href, '_blank');
      },
    getTestTotal(status) {
      return this.totalTest.find((p) => p.id === status.id)?.total || 0;
    },
    getTestAvg(status) {
      if (this.totalTest){
      return this.totalTest.find((p) => p.id === status.id)?.avg || 0;
	 } else {
        return '---'
      }
    },
      getColorScore(score){
          let style = ""
          // if (x === 0) style += ' row-bold '
          if (score >= 70) return 'green-score' + style
          if (score >= 50) return 'yellow-score'+ style
          if ( score === undefined  || score === null) return  style
          return 'red-score'+ style

      },
    getTotalTest() {
      this.isLoading = true
      this.service
          .getTotalTestPupil(this.pupil.id, this.startDate, this.endDate)
          .then((data) => {

            data?.map((e) => (e.status = this.getStatusObj(e.id)));
            data?.sort((a, b) => (a.status?.sort > b.status?.sort ? 1 : -1));
            this.totalTest = data;
            this.isLoading = false
          });
    },
    getStatusObj(statusId) {
      return this.subjectLesson.find(
          (subject) => subject.id === statusId
      );
    }
  },
  computed: {
      getSubjectLesson(){
        return   this.subjectLesson.filter(s => this.getTestAvg(s) > 0)
      },
    ...mapState(["subjectLesson"])
  },
  watch: {
    pupil() {
      this.isLoading = true
        this.getTotalTest();
    },
    startDate() {
      this.isLoading = true
      this.getTotalTest();
    },
    endDate() {
      this.isLoading = true
      this.getTotalTest();
    }
  }
};
</script >

<style  scoped>
.green-score {
    background-color: rgba(104, 255, 71, 0.67);
}

.yellow-score {
    background-color: rgba(255, 248, 122, 0.63);
}

.red-score {
    background-color: rgba(243, 64, 64, 0.67);
}
.item{
    cursor: context-menu;
}
.no-content {
    text-align: center;
    color: #999999;
}
</style >
